import { render, staticRenderFns } from "./MarketingBoard.vue?vue&type=template&id=6d162314&"
import script from "./MarketingBoard.vue?vue&type=script&lang=js&"
export * from "./MarketingBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports